import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";


import type { Property } from "@ts-types/property";
import type { PersistedProp, PropsDataState } from "./store.types";

const updateOneProp = (props: Property[], newProp: Property | Partial<Property> & { ref: string }) => {
  const ref = newProp.ref;
  const existingIndex = props.findIndex(prop => prop.ref === ref);

  if (existingIndex !== -1) {
    return props.map((prop) =>
      prop.ref === ref ? { ...prop, ...newProp } : prop
    );
  } else {
    if (Object.keys(newProp).length > 1) {
      return [...props, newProp as Property];
    }
    return props;
  }
};

export const usePropsDataStore = create<PropsDataState>()(
  persist(
    (set) => ({
      props: [],
      
      setProps: (newProps: Property[]) => set({ props: newProps }),
      
      setOneProp: (newProp: Property) => set((state) => ({
        props: updateOneProp(state.props, newProp)
      }))
    }),
    {
      name: 'props-selections-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        props: state.props.map((p): PersistedProp => ({
          ref: p.ref,
          checked: p.checked,
          active: p.active,
        }))
      }),
    }
  )
);